/** 成就规则的文字说明（与 iOS RuleText 一致，单元测试见 achieve.test.ts） */
import type { AchievementRule, JSONObject, JSONValue } from "../../core/models";
import { activityName } from "../learn/activity";

function obj(v: JSONValue | null | undefined): JSONObject | null {
  return typeof v === "object" && v !== null && !Array.isArray(v) ? v : null;
}

function num(v: JSONValue | undefined): number | null {
  return typeof v === "number" && Number.isFinite(v) ? Math.round(v) : null;
}

/** 条件："连续 5 天完成写字练习" / "累计 5 次按时完成任务" / "完成互动游戏得分 ≥ 90" */
export function ruleCondition(r: Pick<AchievementRule, "trigger" | "condition">): string {
  const c = obj(r.condition);
  const s: string[] = [];
  const streak = num(c?.streak_days);
  if (streak != null) s.push(`连续 ${streak} 天`);
  const count = num(c?.count);
  if (count != null) s.push(`累计 ${count} 次`);
  if (c?.before_due === true) s.push("按时");
  if (r.trigger === "reminder.acked") s.push("完成提醒");
  else {
    const type = obj(c?.filter)?.activity_type;
    s.push(`完成${typeof type === "string" ? activityName(type) : "任务"}`);
  }
  const score = num(c?.score_min);
  if (score != null) s.push(`得分 ≥ ${score}`);
  return s.join("");
}

/** 奖励："+20 分"。成就规则只发积分，卡牌由家长发（旧数据里的 card 忽略） */
export function ruleReward(reward: JSONValue | null | undefined): string {
  const p = num(obj(reward)?.points);
  return p != null && p > 0 ? `+${p} 分` : "";
}

/** 规则列表里的说明：描述（没有时用条件）· 奖励 · 周期 */
export function ruleSummary(r: Pick<AchievementRule, "trigger" | "condition" | "reward" | "description" | "period">): string {
  const parts = [r.description ? r.description : ruleCondition(r)];
  const rw = ruleReward(r.reward);
  if (rw) parts.push(rw);
  if (r.period === "daily") parts.push("每天一次");
  else if (r.period === "weekly") parts.push("每周一次");
  else if (r.period === "once") parts.push("仅一次");
  return parts.join(" · ");
}

/** 改奖励积分：保留其它字段，去掉旧的卡牌奖励（服务端不再接受） */
export function withPoints(reward: JSONValue | null | undefined, points: number): JSONObject {
  const { card: _card, ...rest } = obj(reward) ?? {};
  return { ...rest, points };
}
